(function () {
  const container = document.getElementById('addresses_list');
  if (!container) return;

  function fixTargetAttr(node) {
    if (node.nodeType === 1 && node.matches('#sl_addresses li a')) {
      if (node.getAttribute('target') === '_blank') {
        node.setAttribute('target', '_self');
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('#sl_addresses li a').forEach(fixTargetAttr);
  });

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.querySelectorAll) {
          node.querySelectorAll('a[target]').forEach(fixTargetAttr);
        }
        fixTargetAttr(node);
      });

      if (mutation.type === 'attributes' && mutation.target.matches('#sl_addresses li a')) {
        fixTargetAttr(mutation.target);
      }
    });
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['target']
  });
})();
